import { tokens as tokensBase } from '@tamagui/themes/v5';
import { createTokens } from 'tamagui';
import { contextColors, contextColorsDark } from '../colors';

// extend tamagui color tokens with context colors
const colorExtended = {
  ...postfixObjKeys(contextColors, 'Light'),
  ...postfixObjKeys(contextColorsDark, 'Dark')
};

function postfixObjKeys<A extends { [key: string]: string }, B extends string>(
  obj: A,
  postfix: B
): {
  [Key in `${keyof A extends string ? keyof A : never}${B}`]: string;
} {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [`${k}${postfix}`, v])) as any;
}

export const tokens = createTokens({
  ...tokensBase,
  color: colorExtended
});
